import { createAsyncSliceWithDataAndQuery } from 'store/createAsyncSliceWithDataAndQuery';
import {
  getAssociatedLendersAsync,
  getAssociatedLendersForClientAsync,
} from '../../ui-toolkit/associatedLenders/AssociatedLendersAPI';
import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';

export const { slice: associatedLendersDataSlice, asyncAction: loadAssociatedLenders } =
  createAsyncSliceWithDataAndQuery(
    'associatedLendersDataSlice',
    async ({ clientId, userType }: { clientId?: string; userType: eAccessControlUserType }) => {
      // Two different endpoints, when it should be just the one endpoint, so keeping it like this.
      return userType === eAccessControlUserType.Client
        ? await getAssociatedLendersForClientAsync()
        : clientId
          ? await getAssociatedLendersAsync(clientId)
          : [];
    },
    []
  );
